import DKhouseF1 from "../../images/DKhouseF1.svg";
import DKhouseF2 from "../../images/DKhouseF2.svg";
import DKhouseF3 from "../../images/DKhouseF3.svg";
import { ParallaxProvider, Parallax } from "react-scroll-parallax";

const House = () => {
  return (
    <div className="" style={{ position: "relative", minHeight: "100%" }}>
      <ParallaxProvider>
        <Parallax
          translateY={[100, 20]}
          opacity={[1, 0.9]}
          easing="easeOut"
          scale={[0.2, 1]}
        >
          <img draggable={false} src={DKhouseF1} alt="Digikala Group" />
        </Parallax>

        <Parallax
          translateY={[50, 5]}
          opacity={[1, 1]}
          easing="easeOut"
          scale={[0.3, 1]}
        >
          <img
            draggable={false}
            src={DKhouseF2}
            alt="Digikala Group Main Businesslines"
          />
        </Parallax>
        <Parallax
          translateY={[0, 0]}
          opacity={[0.6, 1]}
          easing="easeOut"
          scale={[0.5, 1]}
        >
          <img
            draggable={false}
            src={DKhouseF3}
            alt="Digikala Group Infrastructural Business Lines"
          />
        </Parallax>
      </ParallaxProvider>
    </div>
  );
};

export default House;
